import {
  Box,
  Grid2,
  IconButton,
  Modal,
  ModalProps,
  Typography,
} from "@mui/material";
import { CloseIcon } from "./Icons";
import SimpleLoader from "./SimpleLoader";

interface GKModalProps {
  open: boolean;
  setOpen?: any;
  modalTitle: string;
  maxHeight?: string;
  children: any;
  width?: string | number;
  subTitle?: any;
  footer?: any;
  titleComponent?: any;
  closeBtn?: any;
  escClose?: boolean;
  onCloseModal?: any;
  loading?: boolean;
}

const GKModal = (props: ModalProps & GKModalProps) => {
  const {
    open,
    setOpen,
    children,
    width,
    footer,
    modalTitle,
    titleComponent,
    subTitle,
    closeBtn = true,
    escClose = true,
    onCloseModal,
    loading,
    maxHeight,
    ...restProps
  } = props;

  return (
    <Modal
      {...restProps}
      open={open}
      onClose={() => {
        if (escClose) setOpen(false);
      }}
      style={{ borderRadius: 10 }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 0,
        }}
      >
        <Grid2
          container
          width={width || "50%"}
          className="content-grid"
          style={{
            borderRadius: 10,
            background: "var(--white)",
          }}
        >
          <Grid2
            size={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            p={2}
            pb={0}
          >
            <Typography
              color={"var(--black)"}
              fontSize={18}
              fontWeight={700}
              whiteSpace={"nowrap"}
            >
              {modalTitle}
              {subTitle && (
                <Typography
                  color={"var(--primary-900)"}
                  fontSize={14}
                  fontWeight={400}
                >
                  {subTitle}
                </Typography>
              )}
            </Typography>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              {titleComponent}
              {closeBtn && (
                <IconButton
                  onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    onCloseModal && onCloseModal();
                    setOpen(false);
                  }}
                  sx={{
                    borderRadius: 6,
                    color: "var(--neutral-500)",
                    background: "transparent",
                    border: "none",
                    "&:hover": {
                      color: "var(--neutral-500)",
                      background: "transparent",
                      border: "none",
                    },
                  }}
                >
                  <CloseIcon width={20} height={20} />
                </IconButton>
              )}
            </span>
          </Grid2>

          <Grid2
            size={12}
            py={2}
            maxHeight={maxHeight || "400px"}
            overflow={"auto"}
            sx={{
              "& .MuiTableContainer-root": {
                width: "unset",
              },
              p: 2,
            }}
          >
            {loading ? <SimpleLoader /> : children}
          </Grid2>

          {footer && (
            <Grid2
              p={2}
              pt={0}
              size={12}
              justifyContent={"flex-end"}
              display={"flex"}
              gap="10px"
            >
              {footer}
            </Grid2>
          )}
        </Grid2>
      </Box>
    </Modal>
  );
};

export default GKModal;
